module.exports = __webpack_public_path__ + "img/vignettes-asso_0000_association-saint-jacques.0fa9576f.jpg";